import React from 'react';
import styled from 'styled-components';
import { RenderIf } from '../../common/organisms';
import i18next from 'i18next';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { Button } from 'planoplan-ui-kit/core/button';

export const Balance = ({ goods, openStore, onClose }) => {
  const onClick = () => {
    openStore();
    onClose();
  };
  return (
    <RenderIf cond={goods}>
      <Container>
        {goods.map(({ caption, view_name, view_disabled, count, id }) => (
          <Item key={id} disabled={view_disabled}>
            <Name>{view_name ? view_name : caption}</Name>
            <Count>{count}</Count>
          </Item>
        ))}
        <Button onClick={onClick} size="S">
          {i18next.t('cabinet.widget.balance')}
        </Button>
      </Container>
    </RenderIf>
  );
};

const Container = styled.div`
  font-size: 14px;
  padding: 20px 18px 14px 18px;
  border-radius: 10px;
  background-color: ${Colors.white};
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.15);
  margin-top: 5px;
`;

const Item = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  text-align: left;
  font-weight: 300;
  line-height: 17px;
  margin-bottom: 17px;
  color: ${(p) => (p.disabled ? Colors.light_gray : Colors.coal)};
`;

const Name = styled.div`
  flex-grow: 1;
  padding-right: 10px;
`;

const Count = styled.div`
  font-weight: 500;
  font-size: 16px;
  padding-right: 16px;
`;
